import index from './pages/Index';
import show from './pages/Show';

export default [
    {
        path: '/profile',
        name: 'profile.index',
        meta: {
            title: "Perfis",
            permission: 'profile.list'
        },
        component: index
    },
    {
        path: '/profile/:id',
        name: 'profile.show',        
        meta: {
            title: "Perfil",
            permission: 'profile.show'
        },
        component: show,
    }
];